import { render, staticRenderFns } from "./EpBenefitCardLoan.vue?vue&type=template&id=dd990f48&"
import script from "./EpBenefitCardLoan.vue?vue&type=script&lang=js&"
export * from "./EpBenefitCardLoan.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefitCardLoan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports